import toPairs from 'lodash/toPairs';
import kebabCase from 'lodash/kebabCase';

export default (style) => toPairs(style).reduce((reseter, [key, value]) => `${reseter}${kebabCase(key)}:${value};`, '');
